import React from 'react';
import { getVersionString } from '../config/version';

const VersionFooter = ({ className = '' }) => {
  return (
    <footer className={`text-center py-2 text-xs text-gray-400 print:text-gray-600 ${className}`}>
      {getVersionString()}
    </footer>
  );
};

export default VersionFooter;
